import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GMap from '@geo/react-grabmaps-gl';
import './map.less';

/**
 * @type {import('react').CSSProperties}
 */
const mapStyle = {
  width: '100%',
  height: '100%',
};

const Map = ({ options, fitBounds, fitBoundsPadding, children }) => {
  // This doesn't include all the event, event types are not exported
  /**
   * @type {import('react').FunctionComponent<import('@geo/react-grabmaps-gl/lib/map').Props>}
   */
  const GrabMap = useMemo(
    () => {
      // Configure map options to fix passive touchmove event issue
      // https://app.datadoghq.com/error-tracking/issue/83e311a6-aa35-11f0-8da5-da7ad0900002
      const mapOptions = {
        ...options,
        injectCSS: false,
        // Configure touch gesture handlers to work with passive event listeners
        touchPitch: false, // Disable pitch on touch to prevent preventDefault conflicts
        pitchWithRotate: false, // Disable pitch with rotate gesture
      };

      return GMap(mapOptions);
    },
    [options],
  );

  return (
    <GrabMap
      fitBounds={fitBounds}
      fitBoundsOptions={{ padding: fitBoundsPadding }}
      style={mapStyle}
    >
      {children}
    </GrabMap>
  );
};

Map.propTypes = {
  options: PropTypes.shape({
    minZoom: PropTypes.number,
    maxZoom: PropTypes.number,
  }),
  fitBounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  fitBoundsPadding: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
  }),
  children: PropTypes.node,
};

Map.defaultProps = {
  options: {
    minZoom: 0,
    maxZoom: 18,
  },
  fitBounds: undefined,
  fitBoundsPadding: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  children: null,
};

export default Map;
